import { render, staticRenderFns } from "./WaterfallFeed.vue?vue&type=template&id=256a072a&scoped=true"
import script from "./WaterfallFeed.vue?vue&type=script&lang=js"
export * from "./WaterfallFeed.vue?vue&type=script&lang=js"
import style0 from "./WaterfallFeed.vue?vue&type=style&index=0&id=256a072a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256a072a",
  null
  
)

export default component.exports